/**
 * Convert a Laravel Storage relative path (e.g. /storage/photos/1/abc.jpg)
 * into a fully-qualified URL using the configured API base origin.
 */
export function getStorageUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const origin = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api')
    .replace(/\/api$/, '');
  return `${origin}${path}`;
}
